import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { IDriver } from '@/modules/driver/model/driver';
import { ChangeEmailTip } from '@/shared/view/ChangeEmailTip';
import { DescriptionList } from '@/shared/view/DescriptionList';

import s from './PersonalInfo.module.css';

interface IProps {
  driver: IDriver;
  className?: string;
}

const mapToPersonalInfo = (driver: IDriver) => ({
  birthday: driver.birthday,
  phone: driver.phone,
  email: driver.email,
});

type TTitleLine = [keyof ReturnType<typeof mapToPersonalInfo>, string, React.FC?];

const PersonalInfo = ({ className, driver }: IProps) => {
  const intl = useIntl();

  const titles = useMemo(
    (): Array<TTitleLine> => [
      [
        'phone',
        intl.formatMessage({
          defaultMessage: 'Phone',
          id: 'DT8Cy2',
          description: 'Driver screen: title',
        }),
      ],
      [
        'birthday',
        intl.formatMessage({
          defaultMessage: 'Date of birth',
          id: 'lN7jvS',
          description: 'Driver screen: title',
        }),
      ],
      [
        'email',
        intl.formatMessage({
          defaultMessage: 'Email',
          id: 'x7vKKw',
          description: 'Driver screen: title',
        }),
      ],
    ],
    [intl],
  );

  const values = useMemo(() => mapToPersonalInfo(driver), [driver]);

  return (
    <DescriptionList
      title={intl.formatMessage({
        defaultMessage: 'Personal info',
        id: 'K02gga',
        description: 'Driver screen: Personal info section heading',
      })}
      className={className}
      values={values}
      titles={titles}
      action={
        <Link to={`/chauffeurs/${driver.id}/edit-info`} className={s.edit}>
          {intl.formatMessage({
            defaultMessage: 'Edit',
            id: 'global_action_edit',
            description: 'Profile screen: button text',
          })}
        </Link>
      }
    >
      <ChangeEmailTip />
    </DescriptionList>
  );
};

export { PersonalInfo };
